import { render, staticRenderFns } from "./ui-switcher.vue?vue&type=template&id=fc5e9454&scoped=true&"
import script from "./ui-switcher.vue?vue&type=script&lang=ts&"
export * from "./ui-switcher.vue?vue&type=script&lang=ts&"
import style0 from "./ui-switcher.vue?vue&type=style&index=0&id=fc5e9454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5e9454",
  null
  
)

export default component.exports